export interface ApiErrorResponse {
  timestamp: string;
  status: number | null;
  message: string | null;
  debugMessage: string | null;
  errors: string[] | null;
}

/**
 * Parsuje odpowiedź błędu z API i zwraca czytelny komunikat
 * @param error Obiekt błędu z HTTP
 * @param fallbackMessage Komunikat domyślny jeśli nie można sparsować błędu
 * @returns Czytelny komunikat błędu
 */
export function parseApiError(error: any, fallbackMessage: string = 'Wystąpił nieoczekiwany błąd'): string {
  if (!error) {
    return fallbackMessage;
  }

  // Jeśli error ma strukturę ApiErrorResponse
  if (error.error && typeof error.error === 'object') {
    const apiError = error.error as ApiErrorResponse;

    // Priorytet: message > errors (pierwsza) > debugMessage
    if (apiError.message) {
      return apiError.message;
    }

    if (apiError.errors && apiError.errors.length > 0) {
      return apiError.errors[0];
    }

    if (apiError.debugMessage) {
      return apiError.debugMessage;
    }
  }

  // Jeśli nie udało się sparsować odpowiedzi API, zwróć fallback
  // (nie używamy error.message bo to jest "Http failure response...")
  return fallbackMessage;
}
